<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="form-group">
            <input v-model="paramsLocal" class="form-control">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        name: 'SearchPhrase',
        data () {
            return {
            }
        },
        computed: {
            paramsLocal: {
                get () {
                    return this.params
                },
                set (newValue) {
                    this.$emit('update:params', newValue)
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', '')
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchPhrase.vue?695c805d